import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-yesnodialog',
  templateUrl: './yesnodialog.component.html',
  styleUrls: ['./yesnodialog.component.scss'],
})
export class YesnodialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<YesnodialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.data.name = 'okclicked';
  }

  onNoClick(): void {
    this.data.name = 'noclicked';
    this.dialogRef.close();
  }
}
